import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { mainRoutes } from "src/config";

export const useLoginRedirect = () => {
  const history = useHistory();
  const redirect = useCallback(() => {
    const destination = mainRoutes[0].path;
    if (history.location.pathname === destination) return;
    history.push(destination);
  }, [history]);

  return redirect;
};
